export const ALLOY_UTILITY_SKU = "ALLOY-MR-UTILITY-BASE"
